import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { LEAD_TYPES_OPTIONS_FOR_QUOTE_FUNNEL, default_hours_of_operation, default_products_offered } from 'helpers/sf_constants';
import { MetaTags } from 'react-meta-tags';
import { AppConfiguration } from 'config';
import { addPadStart, getUpdatedHostForQF, safeJSONParse } from 'helpers/sf_utils';
import runded_phone_icon from "assets/images/rounded-circle-phone.svg"
import Header from 'pages/QuoteFunnelAnswer/QuoteFunnelAnswerLayout/Header';
import { getCampaignsByAccount } from 'store/actions';
import { formatPhoneNumber } from 'helpers/quote_funnel_helper';
// import image_url from '../../assets/images/users/avatar-9.jpg'

const QuoteFunnelPreview = () => {
    const dispatch = useDispatch();

    const {
        answer_agent_profile,
        current_account,
        answer_agent_profile_loading
    } = useSelector((state) => ({
        answer_agent_profile: state.QuoteFunnelRedcuer.agent_profile,
        answer_agent_profile_loading: state.QuoteFunnelRedcuer.agent_profile_loading,
        current_account: state.accounts.current_account,
    }));
    const productsOffered = safeJSONParse(answer_agent_profile?.products_offered, default_products_offered);

    useEffect(() => {
        dispatch(getCampaignsByAccount({
            account_ids: current_account?.id, // at least one account should be selected
        }))
    }, [current_account]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    let address = `${answer_agent_profile?.name} ${answer_agent_profile?.address} ${answer_agent_profile?.city} ${answer_agent_profile?.zip_code}`

    const renderedProducts = productsOffered?.map((productValue) => {
        const product = LEAD_TYPES_OPTIONS_FOR_QUOTE_FUNNEL.find((item) => item.value.toString() === productValue.lead_type_id.toString() && productValue.is_active);
        return product ? product.label : null;
    });
    const page_title = `Quote Funnel Preview | ${AppConfiguration.WEBSITE}`;
    const first_name = null

    const getRedirectionLink = (url) => {
        const newHost = getUpdatedHostForQF();
        return `http://${newHost}${url}`;
    };

    const footerLinksatQuoteFunnel = [
        { href: getRedirectionLink('/privacy-policy'), name: 'Privacy Policy' },
        { href: getRedirectionLink('/terms-of-use'), name: 'Terms of Use' },
        { href: getRedirectionLink('/ccpa-opt-out'), name: 'Do not Sell my personal information' },
        { href: getRedirectionLink('/privacy-policy#special-notice-california'), name: 'California Privacy Choices' },
        { href: getRedirectionLink('/privacy-policy#cookies-and-technologies'), name: 'Cookies and Other Technology' }
    ];
    return (
        <div className='quote-funnel-div-wrapper'>
            <div className="page-content quote-funnel-div" style={{ padding: '0px' }}>
                <React.Fragment>
                    <MetaTags>
                        <title>{page_title}</title>
                    </MetaTags>

                    <Header answer_agent_profile={answer_agent_profile || null}
                        lead_type_id={null}
                        user_name={null}
                        tracking_number={answer_agent_profile?.phone_num}
                        answer_agent_profile_loading={answer_agent_profile_loading}
                    />
                    <Container className='my-5'>
                        <Row className='text-center mb-3'>
                            <Col md="12">
                                <h1 className="text-bold text-black quote-funnel-answer-header quote-funnel-unique-h1">Last Step<span className='text-capitalize'>{(!!first_name && `, ${first_name}`)}</span>.</h1>
                                <p className='quote-funnel-agent-details-info mx-2'>
                                    Call {answer_agent_profile?.name} now to get your quote.

                                </p>

                                <a className="text-white btn quote-funnel-continue-and-quote-btn btn-lg quote-funnel-answer-btn" href={`tel:${answer_agent_profile?.phone_num}`}>
                                    <span className='d-flex justify-content-center align-items-center qf-call-now-btn-small-screen'>
                                        <img src={runded_phone_icon} className='me-1' /> Call Now: {formatPhoneNumber(answer_agent_profile?.phone_num)}
                                    </span>
                                </a>
                            </Col>

                            <div className="d-flex justify-content-center align-item-center quote-funnel-quote-ready">
                                <i className='mdi mdi-circle font-size-16 mt-1' style={{ color: "#36b04b" }} />
                                <span className="ms-2" style={{ marginTop: '6px' }}>Your quote is ready & agents are available</span>
                            </div>
                        </Row>
                    </Container>
                    <div className='quote-funnel-answer-footer p-3'>
                        <Container className='mt-4'>
                            <Row>
                                <Col md={7}>
                                    <section id='qtf-ty-profile-info'>
                                        <div className="d-flex align-items-center">
                                            <div className='quote-funnel-answer-footer-img'>
                                                {!answer_agent_profile_loading && answer_agent_profile?.profile_img_url &&
                                                    <img src={answer_agent_profile?.profile_img_url} style={{ width: "140px", height: "140px" }} alt="User Logo" className="quote-funnel-answer-footer-user-log me-3" />
                                                }
                                            </div>
                                            <div className='w-100'>
                                                <div className='quote-funnel-answer-footer-span-container-profile'>
                                                    <span className='quote-funnel-thank-you-page-company-name'>{answer_agent_profile?.name}</span>
                                                    <span className='fs-18 mb-0 pb-0 text-left'>{answer_agent_profile?.carrier}</span>
                                                    <span className='fs-18 mb-0 pb-0 text-left'>{answer_agent_profile?.address}, {answer_agent_profile?.city}, {answer_agent_profile?.state} {addPadStart(answer_agent_profile?.zip_code)}</span>
                                                    <span className='fs-18 fw-bold text-left' style={{ color: '#3486e5' }}>{formatPhoneNumber(answer_agent_profile?.phone_num)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    {answer_agent_profile?.agency_info && <section id="qtf-ty-about-us">
                                        <div className="products mb-3">
                                            <h4 className='fs-18 fw-bold'>About Us</h4>
                                            {answer_agent_profile?.agency_info && (
                                                <div className='fs-18 agency-info-thank-you-page'>
                                                    {answer_agent_profile?.agency_info?.split('\n')?.map((paragraph, index) => (
                                                        <p key={index}>{paragraph}</p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </section>}
                                    <section id="qtf-ty-hours-of-operation">
                                        <h4 className='fs-18 fw-bold'>Hours of Operation</h4>
                                        {(safeJSONParse(answer_agent_profile?.hours_of_operation, default_hours_of_operation))?.map((operation, index) => (
                                            <span className='d-flex fs-18'>
                                                <span className='text-capitalize' style={{ minWidth: '100px' }}>{operation?.day || ""}</span>
                                                <span className='ms-3'>{operation?.is_active ? (`${operation?.from || ""} - ${operation?.to || ""}`) : "Closed"}</span>
                                            </span>
                                        ))}
                                    </section>

                                </Col>
                                <Col md={5}>
                                    <section id="qtf-ty-map">
                                        <div className='w-100'>
                                            <iframe
                                                title="Google Map"
                                                className="quote-funnel-answer-footer-border"
                                                src={`https://maps.google.com/maps?width=500&height=400&hl=en&q=${encodeURIComponent(address)}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}
                                            ></iframe>
                                        </div>
                                    </section>
                                    {renderedProducts && renderedProducts.some(product => product !== null) && (
                                        <section id="qtf-ty-products">
                                            <h4 className='fs-18 fw-bold'>Products Offered</h4>
                                            <ul className="row" style={{ margin: 0, padding: 0 }}>
                                                {renderedProducts.map((product, index) => product && (
                                                    <li className='col-md-6 col-sm-6 fs-16' style={{ listStyleType: "none", marginBottom: "2px", padding: 0 }} key={index}>
                                                        <span className="d-flex fs-18 align-items-top">
                                                            <i className="bx bx-check pt-1 fw-bold me-1 fs-18" aria-hidden="true" style={{ color: '#3486e5' }}></i>
                                                            {product}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </section>
                                    )}
                                    {answer_agent_profile?.languages && answer_agent_profile.languages.length > 0 && (
                                        <section id="qtf-ty-languages-spoken">
                                            <h4 className='fs-18 fw-bold'>Languages Spoken</h4>
                                            {answer_agent_profile.languages.map((language, index) => (
                                                <ul key={index} style={{ margin: 0, padding: 0 }}>
                                                    <li className='d-flex fs-18 align-items-center' style={{ listStyleType: "none", marginBottom: "8px", padding: 0, lineHeight: '1.2' }}>
                                                        {language}
                                                    </li>
                                                </ul>
                                            ))}
                                        </section>
                                    )}
                                </Col>
                            </Row>
                            <div className={`quote-funnel-answer-footer-span-container my-4`}>
                                <span className='fs-16'>
                                    Powered by Goal
                                </span>
                                <span>
                                    <div className='footer-links mt-2'>
                                        {footerLinksatQuoteFunnel.map((link, index) => (
                                            <span key={index} className='ms-2 mb-2' style={{ color: '#3486e5' }}>
                                                <a href={link.href} target='_blank' className="text-sfblue">{link.name}</a> {!(index == footerLinksatQuoteFunnel.length - 1) && <span className='footer-links-line ms-2'>|</span>}
                                            </span>
                                        ))}
                                    </div>
                                    <span className='small d-flex justify-content-center mx-2'>As part of our ongoing effort to provide you with the best possible service, Goal Platform LLC and its Service Providers may monitor and/or record and retain all activity on this website and its applicable links, through the use of cookies, tracking pixels or other methods, for informational and quality control purposes.</span>
                                </span>
                            </div>
                        </Container>
                    </div>
                </React.Fragment>
            </div>
        </div>
    )
};

export default QuoteFunnelPreview;
